import React, { Component } from 'react';
import './badges-box.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import {
  PrimaryButton
} from '../../components';

export default class BadgesBox extends Component {
  componentWillMount() {
    AOS.init();
  }

  render() {
    return (
      <div className="rdp-react-template-component-badges-box">
        <span className="rdp-react-template-component-badges-box-back" onClick={() => this.props.onClose()}></span>
        <div className="rdp-react-template-component-badges-box-badge" data-aos="fade-up" data-aos-duration="500">
          <span className="rdp-react-template-component-badges-box-badge-label">{this.props.badgeLabel}</span>
        </div>
        <h1 className="rdp-react-template-component-badges-box-title" data-aos="fade-up" data-aos-duration="1000">{this.props.title}</h1>
        <p className="rdp-react-template-component-badges-box-message" data-aos="fade-up" data-aos-duration="2000" dangerouslySetInnerHTML={{__html: this.props.message}}></p>
        <div data-aos="fade-up" data-aos-duration="3000" style={{marginTop: "30px"}}>
          <PrimaryButton
            label={this.props.buttonLabel || "Voltar"}
            icon="talk"
            onClick={() => this.props.onClose && this.props.onClose()}
          />
        </div>
      </div>
    );
  }
}
